<template>
  <path
    fill="currentColor"
    d="M1.263 8.21h6.948V1.264A1.263 1.263 0 0 1 9.474 0h5.052a1.264 1.264 0 0 1 1.263 1.263v6.948h6.948A1.264 1.264 0 0 1 24 9.474v5.052a1.263 1.263 0 0 1-1.263 1.263h-6.948v6.948A1.264 1.264 0 0 1 14.526 24H9.474a1.263 1.263 0 0 1-1.263-1.263v-6.948H1.263A1.264 1.264 0 0 1 0 14.526V9.474a1.263 1.263 0 0 1 1.263-1.263Z"
  />
</template>
